<template>
  <v-card hover outlined height="350px">
    <v-img
      v-if="defaultTranslation && defaultTranslation.template && defaultTranslation.preview"
      :src="defaultTranslation.preview"
      :lazy-src="defaultTranslation.preview"
      contain
      height="200"
      class="grey lighten-2"
    >
      <template v-slot:placeholder>
        <v-row
          class="fill-height ma-0"
          align="center"
          justify="center"
        >
          <v-progress-circular indeterminate color="grey lighten-5" />
        </v-row>
      </template>
    </v-img>
    <v-alert
      v-else
      :value="true"
      :color="alert.color"
      :class="alert.class"
      border="top"
      height="200"
      width="100%"
      class="ma-0 d-flex align-center justify-center"
    >
      <div style="width: 100%;" class="d-flex flex-column align-center justify-center">
        <v-icon
          v-text="alert.icon"
          :color="alert.iconColor"
          size="50"
        />
        <div
          v-text="alert.text"
          class="overline font-weight-bold text-center"
          style="max-width: 160px;"
        />
      </div>
    </v-alert>
    <v-checkbox
      ref="template-card-checkbox"
      v-if="defaultTranslation && defaultTranslation.template && selectabled"
      v-model="inputValue"
      :value="template.id"
      :value-comparator="() => template.id === value"
      color="primary"
      hide-details
      dense
      small
      class="ma-0 pa-0"
      style="position: absolute; top: 12px; left: 12px;"
    />
    <v-card-text style="height: calc(100% - 244px);">
      <v-row dense>
        <v-col cols="12" class="title text-truncate">
          {{ template.name }}
        </v-col>
        <v-col v-if="template.description" cols="12" class="text-truncate-2">
          {{ template.description }}
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions v-if="show || edit || remove">
      <v-btn
        ref="template-card-button-show"
        v-if="show"
        @click="$emit('show')"
        text
        small
        color="primary"
      >
        <v-icon left>
          open_in_new
        </v-icon>
        {{ $t('actions.preview') }}
      </v-btn>
      <v-spacer />
      <v-btn
        ref="template-card-button-edit"
        v-if="edit"
        icon
        small
        class="pa-0 ma-0"
      >
        <v-icon @click="$emit('edit')" small>
          edit
        </v-icon>
      </v-btn>
      <v-btn
        ref="template-card-button-remove"
        v-if="remove"
        @click="$emit('remove')"
        icon
        small
        class="pa-0 ma-0"
      >
        <v-icon small>
          delete
        </v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'TemplateCard',
  props: {
    value: {
      type: Number,
      required: false,
      default: null
    },
    selectabled: {
      type: Boolean,
      required: false
    },
    template: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      required: false
    },
    edit: {
      type: Boolean,
      required: false
    },
    remove: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('change', value)
      }
    },
    defaultTranslation() {
      if (this.template && this.template.translations && this.template.translations.length) {
        return this.template.translations[0]
      }
      return null
    },
    alert() {
      if (!this.defaultTranslation) {
        return {
          color: 'error lighten-4',
          icon: 'error',
          iconColor: 'error',
          class: 'error--text',
          text: 'Plantilla sin traducción por defecto'
        }
      }
      if (!this.defaultTranslation.template) {
        return {
          color: 'orange lighten-4',
          icon: 'warning',
          iconColor: 'warning',
          class: 'warning--text',
          text: this.$t('templates.detail.empty_design')
        }
      } 
      return {
        color: 'blue lighten-4',
        icon: 'info',
        iconColor: 'info',
        class: 'info--text',
        text: this.$t('templates.preview_not_available')
      }
    }
  }
}
</script>
